var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceOverspeed01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_153_00000161605250821351881370000006137615988694255755_",
    d: "M241.9,72.7c-53.9,3-105.2,24.2-145.5,60.2l60,60 c27.6-9.8,57.7-9.6,85.3,0.3L241.9,72.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154_00000156577836462958476480000017811774307519864998_",
    d: "M296.5,231.9l113.6-103.6 c-39.4-33.2-88.6-52.7-140-55.6v135C280,214.5,288.9,222.7,296.5,231.9L296.5,231.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155_00000155848610491755055550000004477594406287971503_",
    d: "M16,312.3v14.1h56.2v-14.1 c0-42.9,21.7-82.8,57.7-106.1l-53.3-53.3C37.5,196.7,15.9,253.5,16,312.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156_00000058586898894666159210000009457144750341101455_",
    d: "M421.4,326.3H496v-14.1c0-20.2-2.5-40.3-7.5-59.8 L421.4,326.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157_00000065064342968401167230000009221441610254744987_",
    d: "M256,326.8c-31.1,0-56.2,25.2-56.2,56.3 c0,31.1,25.2,56.2,56.3,56.2c31.1,0,56.2-25.2,56.2-56.3c0-14.9-5.9-29.2-16.5-39.8C285.2,332.7,270.9,326.8,256,326.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158_00000013881876424741979510000011687985689168272291_",
    d: "M436.2,142.6L264.6,299.1c39.7,4.1,71,35.5,75.1,75.2 l156.1-171.9v-59.8H436.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceOverspeed01);
export default __webpack_public_path__ + "static/media/deviceOverspeed-01.0398b96e8a0de06d1aa1e481239a3fb7.svg";
export { ForwardRef as ReactComponent };